import styled from "styled-components";

export interface iContainerProps {
    backgroundColor?: string,
}

export const Container = styled.main<iContainerProps> `

    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus, 
    input:-webkit-autofill:active{
        -webkit-box-shadow: 0 0 0 30px #212121 inset !important;
        box-shadow: 0 0 0 30px #212121 inset !important;
        -webkit-text-fill-color: #BDBDBD !important;
    }

    margin: 0;
    padding: 0;
    min-width: 100vw;
    min-height: 100vh;
    padding: 16px;
    padding-bottom: 0;
    background-color: ${props => props.backgroundColor || props.theme.colors.brand4.dark};
    box-sizing: border-box;
    display: flex;

    small{
        color: ${props => props.theme.colors.error.pure};
        margin-bottom: 50px;
        display: flex;
        align-items: center;
        margin-left: 10px;
        margin-top:-10px;
    }

    @media screen and (min-width: 480px) { 
        align-items: center;
        justify-content: center;
        margin-bottom: 0px;
    } 
`

export const Form = styled.form`
    position: relative;
    display: flex;
    flex-direction: column;     
    width: 100%;
    height: 100%;

    @media screen and (min-width: 480px) { 
        width: 420px;
    }
`
